import './styles.scss';

import { ComponentProps, ReactElement } from 'react';

import LottieReact from 'lottie-react';
import { getClasses } from '@/utils';
import loading from './animations/loading.json';
import loading_spinner from './animations/loading_spinner.json';
import maintenance from './animations/maintenance.json';
import not_found from './animations/not_found.json';

const animations = {
  LoadingSpinner: loading_spinner,
  Maintenance: maintenance,
  NotFound: not_found,
  Loading: loading,
};

export type LottieProps = {
  name: keyof typeof animations;
  loop?: boolean;
} & ComponentProps<'div'>;

const Lottie = ({ name, loop = true, children, ...props }: LottieProps): ReactElement => (
  <div {...props} className={getClasses('Lottie Common', `Lottie-${name}`, props.className)}>
    <LottieReact animationData={animations[name]} loop={loop} />
    {children}
  </div>
);

export default Lottie;
